<template>
    <div class="text-center">
      <v-dialog persistent v-model="visible" width="600">
        <v-card class="not-margin pt-0 pr-0 pl-0">
          <v-toolbar dark color="primary">
            <div class="text-center">
              <v-icon>mdi-eye</v-icon> Visualizar Disciplina
            </div>
          </v-toolbar>
          <div class="container dialog">
            <v-row class="justify-center mt-7">
              <v-col cols="12">
                <v-text-field
                  :value="content.nome"
                  label="Nome da Disciplina"
                  readonly
                  outlined
                  dense
                ></v-text-field>
                <v-text-field
                  :value="content.tipoDisciplina.tipoDisciplina"
                  label="Tipo de Disciplina"
                  readonly
                  outlined
                  dense
                ></v-text-field>
                <v-textarea
                  :value="content.descricao"
                  label="Descrição"
                  counter="500"
                  readonly
                  outlined
                  dense
                  rows="6"
                ></v-textarea>
                <v-textarea
                  :value="content.ementa"
                  label="Ementa"
                  counter="1000"
                  readonly
                  outlined
                  dense
                  rows="6"
                ></v-textarea>
              </v-col>
            </v-row>
          </div>
          <div class="btn-group text-center">
            <v-btn color="primary" @click="$emit('onClose')">
              Fechar
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
  import { DialogProps } from '~/commons/classes/dialog-props';
  import { Disciplina } from '~/commons/classes/disciplina';
  
  export default {
    props: new DialogProps(Disciplina),
  }
  </script>